export const THEMES = {
  Advantage: 'advantage',
  ASB: 'asb',
  Bendigo: 'bendigo',
  CMC: 'cmc',
  CMCAlpha: 'cmcinvestalpha',
  CMCSingapore: 'cmcinvestsingapore',
  eBroking: 'ebroking',
  Rivkin: 'rivkin',
  StGeorge: 'stgeorge',
  Westpac: 'westpac'
  // ANZMola: 'mola',
  // ANZCollateralise: 'collateraliseportal'
} as const;

export type Theme = (typeof THEMES)[keyof typeof THEMES];

export const THEME_PATHS = {
  partners: 'partners',
  asb: 'asb',
  bendigo: 'bendigo',
  au: 'au',
  alpha: 'alpha',
  sg: 'sg',
  ebroking: 'ebroking',
  rivkin: 'rivkin',
  stgeorge: 'stgeorge',
  westpac: 'westpac'
} as const;

export type ThemePath = (typeof THEME_PATHS)[keyof typeof THEME_PATHS];

export const themesHaveMBLA = [THEMES.CMC, THEMES.Advantage, THEMES.Rivkin, THEMES.CMCAlpha, THEMES.CMCSingapore];
export const themesCmc = [THEMES.CMC, THEMES.CMCAlpha];
